import subsidiaryClaimService from '@rd-web-markets/shared/dist/services/claim/subsidiary_claim.service';
import React, { useCallback, useState } from 'react';
import TotalCostData from './TotalCostData';
import { Tab, Tabs } from 'react-bootstrap';
export default function TotalCostTabs(_ref) {
  let {
    claim,
    setClaim,
    saveClaim
  } = _ref;
  const [key, setKey] = useState('claim');
  const {
    subsidiaryClaims,
    updateSubsidiaryClaimState,
    updateSubsidiaryClaim
  } = subsidiaryClaimService.useCrud({
    claimId: claim.id
  });
  const getSelectedSubsidiaryClaim = selectedTabKey => {
    const subsidiaryClaim = subsidiaryClaims?.find(sc => sc.id.toString() === selectedTabKey);
    return subsidiaryClaim;
  };
  return /*#__PURE__*/React.createElement(Tabs, {
    activeKey: key,
    onSelect: k => setKey(k),
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "claim",
    title: "Claim"
  }, key === 'claim' && /*#__PURE__*/React.createElement(TotalCostData, {
    claim: claim,
    setClaim: setClaim,
    saveClaim: saveClaim
  })), claim.company?.has_subsidiary_companies && subsidiaryClaims?.map(subsidiaryClaim => /*#__PURE__*/React.createElement(Tab, {
    key: subsidiaryClaim.id,
    eventKey: subsidiaryClaim.id.toString(),
    title: subsidiaryClaim.subsidiary_company?.name || `Subsidiary ${subsidiaryClaim.id}`
  }, key !== 'claim' && /*#__PURE__*/React.createElement(TotalCostData, {
    claim: getSelectedSubsidiaryClaim(key),
    setClaim: updateSubsidiaryClaimState,
    saveClaim: updateSubsidiaryClaim
  }))));
}